import { overrideBaseLocale } from './base-config';
export var enTW = overrideBaseLocale('en-TW', {});
//# sourceMappingURL=en-TW.js.map